export default __webpack_public_path__ + "static/home-process-renovation-footer-392d7bec73f903a8c6b8e4c339581154.png";